export default __webpack_public_path__ + "static/media/island_2_with_objects.a7dacd8b.png";